import { WebglObject } from "../../../../web-graphics";

export class PlotVerticalLine extends WebglObject {
  constructor(settings) {
    super(settings);

    this.buffer = PlotVerticalLine.createDataBuffer(this.settings.absoluteLocation, this.settings.sizeInPixels);

    this.uniforms = {
      u_color: new Float32Array(this.settings.color),
      u_shift: new Float32Array([0.0, 0.0]),
      u_rollIndex: 0,
      u_scale: new Float32Array([1, 1]),
      u_windowSize: new Float32Array([this.settings.canvas.settings.sizeInPixels.width, this.settings.canvas.settings.sizeInPixels.height])
    };

    this.glBuffer = this.settings.gl.createBuffer();
    this.settings.gl.bindBuffer(this.settings.gl.ARRAY_BUFFER, this.glBuffer);
    this.settings.gl.bufferData(this.settings.gl.ARRAY_BUFFER, this.buffer, this.settings.gl.STATIC_DRAW);
  }

  static createDataBuffer(location, size) {
    return new Float32Array([location.x, location.y, location.x, location.y + size.height]);
  }

  setPosX(x) {
    this.uniforms.u_shift[0] = x % this.settings.parent.ref.settings.sizeInPixels.width;
  }

  createBorders() {
    super.createBorders();
    this.updateDataBuffer();
  }

  updateDataBuffer() {
    this.uniforms.u_windowSize = new Float32Array([this.settings.canvas.settings.sizeInPixels.width, this.settings.canvas.settings.sizeInPixels.height]);
    this.buffer = PlotVerticalLine.createDataBuffer(this.settings.absoluteLocation, this.settings.sizeInPixels);
    this.settings.gl.bindBuffer(this.settings.gl.ARRAY_BUFFER, this.glBuffer);
    this.settings.gl.bufferData(this.settings.gl.ARRAY_BUFFER, this.buffer, this.settings.gl.STATIC_DRAW);
  }

  draw(gl, program) {
    if (!this.settings.isVisible) {
      return;
    }
    gl.viewport(0, 0, this.settings.canvas.settings.sizeInPixels.width, this.settings.canvas.settings.sizeInPixels.height);
    program.setUnforms(this.uniforms);
    gl.enableVertexAttribArray(program.attribs.a_position);
    gl.bindBuffer(gl.ARRAY_BUFFER, this.glBuffer);
    gl.vertexAttribPointer(program.attribs.a_position, 2, gl.FLOAT, false, 0, 0);
    gl.drawArrays(gl.LINES, 0, this.buffer.length / 2);
  }
}
